@if (meta.readOnlyMarketData() && bannerVisible()) {
<div class="ro-banner" role="status" aria-live="polite">
	<span class="ro-banner__msg">
		<strong>Read-only mode:</strong>
		connected to PRODUCTION market data ({{ meta.environment() }}). Writes to ClickHouse are
		disabled.
	</span>
	<button
		type="button"
		class="ro-banner__close"
		[attr.aria-label]="'nav.roBanner.hideAria' | translate"
		[title]="'nav.roBanner.hideTitle' | translate"
		(click)="dismissBanner()"
	>
		×
	</button>
</div>
} @else if (meta.readOnlyMarketData() && !bannerVisible()) {
<button
	type="button"
	class="ro-banner__pill"
	[attr.aria-label]="'nav.roBanner.showAria' | translate"
	[title]="'nav.roBanner.showTitle' | translate"
	(click)="showBanner()"
>
	RO
</button>
} @if (isSpecialPage()) {
<router-outlet></router-outlet>
} @else { @if (showCmsShell()) {
<app-cms-layout></app-cms-layout>
} @else {
<app-layout></app-layout>
} }
